import React from "react"

export const SmileyIcon = ({ size = 64, color = "black" }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        width={size}
        height={size * 1.25} // To keep the aspect ratio based on the original viewBox
        viewBox='0 0 64 80'
        enableBackground='new 0 0 64 64'
        xmlSpace='preserve'
    >
        <g fill={color}>
            <path d='M32,2C15.5,2,2,15.5,2,32s13.5,30,30,30s30-13.5,30-30S48.5,2,32,2z M40,17c2.2,0,4,1.8,4,4s-1.8,4-4,4c-2.2,0-4-1.8-4-4   S37.8,17,40,17z M24,17c2.2,0,4,1.8,4,4s-1.8,4-4,4c-2.2,0-4-1.8-4-4S21.8,17,24,17z M32,50c-9.9,0-18-8.1-18-18c0-1.1,0.9-2,2-2   s2,0.9,2,2c0,7.7,6.3,14,14,14s14-6.3,14-14c0-1.1,0.9-2,2-2s2,0.9,2,2C50,41.9,41.9,50,32,50z' />
        </g>
    </svg>
)

export const ShockIcon = ({ size = 64, color = "black" }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        width={size}
        height={size * 1.25} // To keep the aspect ratio based on the original viewBox
        viewBox='0 0 64 80'
        enableBackground='new 0 0 64 64'
        xmlSpace='preserve'
    >
        <g fill={color}>
            <path d='M32,2C15.5,2,2,15.5,2,32s13.5,30,30,30s30-13.5,30-30S48.5,2,32,2z M20,21c0-2.2,1.8-4,4-4s4,1.8,4,4s-1.8,4-4,4   S20,23.2,20,21z M40,42H24c-1.1,0-2-0.9-2-2s0.9-2,2-2h16c1.1,0,2,0.9,2,2S41.1,42,40,42z M40,25c-2.2,0-4-1.8-4-4s1.8-4,4-4   s4,1.8,4,4S42.2,25,40,25z' />
        </g>
    </svg>
)

export const SadIcon = ({ size = 64, color = "black" }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        width={size}
        height={size * 1.25} // To keep the aspect ratio based on the original viewBox
        viewBox='0 0 64 80'
        enableBackground='new 0 0 64 64'
        xmlSpace='preserve'
    >
        <g fill={color}>
            <path d='M32,2C15.5,2,2,15.5,2,32s13.5,30,30,30s30-13.5,30-30S48.5,2,32,2z M36,21c1.1,0,2,0.9,2,2c0,1.1,0.9,2,2,2s2-0.9,2-2   c0-1.1,0.9-2,2-2s2,0.9,2,2c0,3.3-2.7,6-6,6s-6-2.7-6-6C34,21.9,34.9,21,36,21z M20,21c1.1,0,2,0.9,2,2c0,1.1,0.9,2,2,2s2-0.9,2-2   c0-1.1,0.9-2,2-2s2,0.9,2,2c0,3.3-2.7,6-6,6s-6-2.7-6-6C18,21.9,18.9,21,20,21z M46.9,46.7c-0.3,0.2-0.7,0.3-1,0.3   c-0.7,0-1.4-0.4-1.7-1c-2.5-4.3-7.1-7-12.1-7s-9.6,2.7-12.1,7c-0.6,1-1.8,1.3-2.7,0.7c-1-0.6-1.3-1.8-0.7-2.7c3.2-5.6,9.2-9,15.6-9   s12.4,3.4,15.6,9C48.1,45,47.8,46.2,46.9,46.7z' />
        </g>
    </svg>
)
